import { getCouponInfo } from '@buy/services'
import { buyCouponActions, BuyCouponActionTypes } from '@buy/state/coupon/actions'
import { CouponInfoServerResponse, CouponServerData } from '@common/state/coupon/state'
import { isEmpty } from 'lodash-es'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { buyPlanActions } from '@buy/state/plan-data/actions'
import { getLocationState } from '@common/state/selectors'
import { LocationState } from '@common/state/location/state'
import { getPlanData, getProductSettingsData } from '@buy/state/selectors'
import { BuyPlan } from '@buy/state/plan'
import { ProductSettings } from '@buy/state/product-settings'

function* getCouponDetailsSaga(action: ReturnType<typeof buyCouponActions.getCouponDetails>) {
    const { couponCode } = action.payload

    // yield put(buyPlanActions.setBuyPlan(content, { ...labels }, { ...plan }, { ...productSettings }))
    const { locationInfo }: LocationState = yield select(getLocationState)
    const { currencySettings }: ProductSettings = yield select(getProductSettingsData)
    // Get pricing info
    const currencyList = currencySettings.map((currency) => currency.currencyCode)
    const currencies = [...currencyList, locationInfo.currency]
    const currencySet = new Set(currencies)

    let productSKUs = ''

    const plan: BuyPlan = yield select(getPlanData)
    const skuList = new Set()
    if (plan.sKU !== '') skuList.add(plan.sKU)

    plan.sKUSelectors?.forEach((item: any) => {
        skuList.add(item.sku)
    })
    plan.addons?.forEach((addon: any) => {
        skuList.add(addon.sKU)
    })

    productSKUs = Array.from(skuList).join(',')

    try {
        const couponInfoServerResponse: CouponInfoServerResponse = yield call(
            getCouponInfo,
            couponCode,
            productSKUs,
            Array.from(currencySet).join(',')
        )
        if (!isEmpty(couponInfoServerResponse.data)) {
            const couponServerResponseData = couponInfoServerResponse.data as unknown as CouponServerData
            const couponDisclaimer = '' // couponDisclaimer doesn't seem to be used. Clean up later as a separate task

            if (couponServerResponseData) {
                yield put(buyCouponActions.setCouponServerData(couponServerResponseData))
            }
            if (couponDisclaimer) {
                yield put(buyPlanActions.setCouponDisclaimer(couponDisclaimer))
            }
        }
    } catch (e) {
        console.error('unable to get url coupon details')
        // yield put(buyCouponActions.attemptForCMSCoupon())
    }
}

export default function* initializeGetCouponDetailsSaga() {
    yield takeLatest(BuyCouponActionTypes.GET_COUPON_DETAILS, getCouponDetailsSaga)
}
